import { Link } from "react-router-dom";
import HeroImage from "../../assets/home/homeHeroImg.avif";
import styles from "./HomeHero.module.css";

const HomeHero = () => {
  return (
    <div>
      <div className={styles.heroContainer}>
        <div className="section">
          <h1>Australian Priceless Education Institute</h1>

          <div className={styles.heroSection}>
            <div className={styles.heroInfo}>
              سد الفجوة بين التعلم الأكاديمي والتدريب القائم على الكفاءة
            </div>
            <img
              src={HeroImage}
              alt="study group"
              className={styles.homeHeroImg}
            />
            <div className={styles.exploreContainer}>
              <Link to="/courses" className={`primary-btn ${styles.explore}`}>
                اكتشف المزيد
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeHero;
